export default __webpack_public_path__ + "static/media/nodejs.abfaef34.png";